import * as types from '../actions/actionTypes';
import initialState from './initialState';
import _ from 'lodash';

export default function measures(state = initialState.measures, action) {
    switch (action.type) {

        case types.GET_MEASURES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            })
        case types.GET_MEASURES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: null,
                data: {
                    ...state.data,
                    ..._.mapKeys(action.data.results, 'id')
                },
                count: action.data.count || 0,
                updating: new Date()
            })
        case types.GET_MEASURES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.GET_MEASURE_BY_ID_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: null,
                data: {
                    ...state.data,
                    [action.data.id]: action.data
                },
                count: (state.count || state.count === 0) ? state.count + 1 : 1,
                updating: new Date()
            })

        case types.RESET_ALL_INFO:
            return initialState.measures

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/measureReducer.js